import { z } from "zod";
import { RequestType } from "@/types/request";

const checklistItemsSchema = z
  .array(z.string().trim().min(1, "Checklist item cannot be empty"))
  .optional();

export const createGuestRequestSchema = z.object({
  type: z.literal(RequestType.GUEST),
  status: z.string(),
  priority: z.boolean(),
  serviceId: z.string().optional(),
  dueDateTime: z.string().min(1, "Due date is required"),
  bookingId: z.string().min(1, "Reservation is required"),
  roomId: z.string().optional(),
  guestId: z.string().optional(),
  description: z.string().optional(),
  notes: z.string().optional(),
  assignedToStaffId: z.string().optional(),
  teamStaffId: z.string().optional(),
  checklistItems: checklistItemsSchema,
});

export const createInternalRequestSchema = z.object({
  type: z.literal(RequestType.INTERNAL),
  status: z.string(),
  priority: z.boolean(),
  serviceId: z.string().optional(),
  dueDateTime: z.string().min(1, "Due date is required"),
  roomId: z.string().optional(),
  description: z.string().optional(),
  notes: z.string().optional(),
  assignedToStaffId: z.string().optional(),
  teamStaffId: z.string().optional(),
  checklistItems: checklistItemsSchema,
});

export const getCreateRequestSchemaByType = (type: RequestType) => {
  switch (type) {
    case RequestType.GUEST:
      return createGuestRequestSchema;
    case RequestType.INTERNAL:
      return createInternalRequestSchema;
    default:
      return z.object({
        type: z.enum(RequestType),
        status: z.string(),
        priority: z.boolean(),
        serviceId: z.string().optional(),
        dueDateTime: z.string().min(1),
        roomId: z.string().optional(),
        description: z.string().optional(),
        notes: z.string().optional(),
        assignedToStaffId: z.string().optional(),
        teamStaffId: z.string().optional(),
        checklistItems: checklistItemsSchema,
      });
  }
};

export type CreateGuestRequestFormData = z.infer<
  typeof createGuestRequestSchema
>;
export type CreateInternalRequestFormData = z.infer<
  typeof createInternalRequestSchema
>;
